// src/components/Tools/Results/registry.ts
import DnsAllRecordsResults from './DnsAllRecordsResults';
import GauResults from './GauResults';
import IpsResults from './IpsResults';
import IpWhoisResults from './IpWhoisResults';
import LeakedDataResults from './LeakedDataResults';
import ScreenshotResults from './ScreenshotResults';
import SpoofOrNotResults from './SpoofOrNotResults';
import SubdomainsResults from './SubdomainsResults';
import TLDHuntResults from './TLDHuntResults';
import type { ResultsRegistry } from './types';
import TyposquattingResults from './TyposquattingResults';
import Wafw00fResults from './Wafw00fResults';
import WappalyzerResults from './WappalyzerResults';
import WhoisResults from './WhoisResults';

export const resultsRegistry: ResultsRegistry = {
  typosquatting: TyposquattingResults,
  subdomains: SubdomainsResults,
  whois: WhoisResults,
  names_tld: TLDHuntResults,
  spoofornot: SpoofOrNotResults,
  ipwhois: IpWhoisResults,
  leaked_data: LeakedDataResults,
  dns_all_records: DnsAllRecordsResults,
  gau: GauResults,
  screenshot: ScreenshotResults,
  wappalyzer: WappalyzerResults,
  wafw00f: Wafw00fResults,
  ips: IpsResults
};